module.exports = __webpack_public_path__ + "media/src/images/logo-iversity-without-padding-376b609125302b52b45a858a0a686736.png";